import { takeEvery, put, call } from "redux-saga/effects";
import type { PayloadAction } from "@reduxjs/toolkit";
import { loadTextSizeFromStorage, saveTextSize } from "helper/textSizeStorage";
import type { TextSize } from "InterfacesTypes/types";
import { loadTextSize, markInitialized, setTextSize } from "state/reducers/TextSizeReducer";

/** Persist on every change */
function* persistTextSize(action: PayloadAction<TextSize>) {
  yield call(saveTextSize, action.payload);
}

/** Load on app start */
function* loadTextSizeSaga() {
  const stored: TextSize | null = yield call(loadTextSizeFromStorage);

  if (stored) {
    yield put(setTextSize(stored));
  }

  yield put(markInitialized());
}

export function* textSizeSaga() {
  yield takeEvery(setTextSize.type, persistTextSize);
  yield takeEvery(loadTextSize.type, loadTextSizeSaga);
}
